<template>
  <div id="Transaction-listing">
    <div class="container admin-wrap mt-5">
      <div class="row header mb-3">
        <div class="col-lg-5">
          <h3 class="text-left">TRANSACTION LISTING</h3>
        </div>
        <div class="col-lg-7"></div>
      </div>
      <div class="row">
        <div class="tl-search-bar">
          <el-select v-on:change="loadSelector()" v-model="ddlDocSelectedValue" placeholder="Select Document Type:">
            <el-option v-for="items in DocsTypeSelection" :label="items.text" v-bind:value="items.value" :key="items.value">{{ items.text }} </el-option>
          </el-select>
          <el-select v-model="ddlSelectedValue" placeholder="Filter By: ">
            <el-option v-for="items in ddlSelection" :value="items.value" :key="items.value">
              {{ items.text }}
            </el-option>
          </el-select>
          <el-date-picker
            v-model="inputFromDate"
            v-if="ddlSelectedValue == 'DateFrom'"
            type="daterange"
            range-separator="TO"
            start-placeholder="From Date"
            end-placeholder="To Date"
            format="dd/MM/yyyy"
            value-format="dd/MM/yyyy"
          >
          </el-date-picker>
          <el-select v-model="inputDateRange" placeholder="Please select Date Range" v-if="ddlSelectedValue == 'DateRange'">
            <el-option v-for="item in DateRangeOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
          <el-button class="" v-if="ddlSelectedValue.length > 0" v-on:click="Search()">Search </el-button>
        </div>
      </div>
      <div class="empty-list_image" v-if="TranInvoiceListInt.length < 1 && TranReceiptListInt.length < 1 && TranCNListInt.length < 1">
        <strong>{{ startupText }}</strong>
        <img src="../assets/notfound.png" />
      </div>
      <div class="row">
        <div class="tl-invoice" v-if="ddlDocSelectedValue === 'Invoice'">
          <div v-if="TranInvoiceListInt.length > 0" class="datatable_group">
            <div class="tl-sub-header">
              <h5 class="text-left mb-3">Transaction List(Invoice)</h5>
              <div class="tl-sub-button">
                <el-button size="small" type="primary" icon="el-icon-download" v-on:click="Download()" :disabled="AuditDisabled">Download</el-button>
              </div>
            </div>
            <data-tables
              :data="TranInvoiceListInt"
              :page-size="pageSize"
              :pagination-props="{ pageSizes: [pageSize, 100] }"
              width="55"
              stripe
              tooltip-effect="light"
              border
              ref="TransactionListTable"
            >
              <el-table-column label="#" min-width="20px">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column v-for="item in TranInvoiceList" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom"> </el-table-column>
            </data-tables>
          </div>
        </div>
        <div class="tl-receipt" v-if="ddlDocSelectedValue === 'Receipt'">
          <div v-if="TranReceiptListInt.length > 0" class="datatable_group">
            <div class="tl-sub-header">
              <h5 class="text-left mb-3">Transaction List(Receipt)</h5>
              <div class="tl-sub-button">
                <el-button size="small" type="primary" icon="el-icon-download" v-on:click="Download()" :disabled="AuditDisabled">Download</el-button>
              </div>
            </div>
            <data-tables
              :data="TranReceiptListInt"
              :page-size="pageSize"
              :pagination-props="{ pageSizes: [pageSize, 100] }"
              width="55"
              stripe
              tooltip-effect="light"
              border
              ref="TransactionListTable"
            >
              <el-table-column label="#" min-width="20px">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column v-for="item in TranReceiptList" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom"> </el-table-column>
            </data-tables>
          </div>
        </div>
        <div class="tl-cn" v-if="ddlDocSelectedValue === 'cn'">
          <div v-if="TranCNListInt.length > 0" class="datatable_group">
            <div class="tl-sub-header">
              <h5 class="text-left mb-3">Transaction List(Credit Note)</h5>
              <div class="tl-sub-button">
                <el-button size="small" type="primary" icon="el-icon-download" v-on:click="Download()" :disabled="AuditDisabled">Download</el-button>
              </div>
            </div>
            <data-tables
              :data="TranCNListInt"
              :page-size="pageSize"
              :pagination-props="{ pageSizes: [pageSize, 100] }"
              width="55"
              stripe
              tooltip-effect="light"
              border
              ref="TransactionListTable"
            >
              <el-table-column label="#" min-width="20px">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column v-for="item in TranCNList" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom"> </el-table-column>
            </data-tables>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataSource from '../data/datasource'
import XLSX from 'xlsx'
import Cookies from 'js-cookie'

export default {
  name: 'TransactionListing',
  async created() {
    // await this.Search();
    //todo: for external auditor only
    let conType = Cookies.get('userTypeSession')
    if (conType === 'Auditor') {
      this.AuditDisabled = true
    }
    //todo: for external auditor only
  },
  async mounted() {},
  data() {
    return {
      ddlSelection: [
        { text: 'Date Range', value: 'DateRange' },
        { text: 'Select Date From/To', value: 'DateFrom' },
      ],
      ddlSelectedValue: '',
      //select option
      DateRangeOptions: [
        {
          value: 'week',
          label: 'Week',
        },
        {
          value: 'month',
          label: 'Month',
        },
        {
          value: 'year',
          label: 'Year',
        },
      ],
      ddlDocSelectedValue: '',
      DocsTypeSelection: [
        { text: 'Invoice', value: 'Invoice' },
        { text: 'Receipt', value: 'Receipt' },
        { text: 'Credit Note', value: 'cn' },
      ],
      //select options
      currentMonthYear: '',
      pageSize: 50,
      startupText: '',
      inputFromDate: [],
      inputDateRange: '',
      inputType: '',
      inputInvoiceDate: [],
      TranInvoiceListInt: [],
      TranInvoiceList: [
        {
          prop: 'Full_Name',
          label: 'First Name',
        },
        {
          prop: 'Last_name',
          label: 'Last Name',
        },
        {
          prop: 'Index_No',
          label: 'Student ID',
        },
        {
          prop: 'IH_Invoice_No',
          label: 'Invoice No',
        },
        {
          prop: 'IH_Invoice_Date_Convert',
          label: 'Invoice Date',
        },
        {
          prop: 'itemTotalAmount',
          label: 'Invoice Amount',
        },
        {
          prop: 'CRS_Course_Name',
          label: 'Level',
        },
        {
          prop: 'classNameBatch',
          label: 'Class',
        },
        {
          prop: 'ID_Item_Description',
          label: 'Fee Item Name',
        },
        {
          prop: 'INV_Invoice_DueDate_Convert',
          label: 'Invoice Due Date',
        },
        {
          prop: 'Remarks',
          label: 'Remarks',
        },
        {
          prop: 'itemBefGSTTotalAmount',
          label: 'itemBefGSTTotalAmount',
        },
      ],

      TranReceiptListInt: [],
      TranReceiptList: [
        {
          prop: 'Full_Name',
          label: 'First Name',
        },
        {
          prop: 'Last_name',
          label: 'Last Name',
        },
        {
          prop: 'Index_No',
          label: 'Student ID',
        },
        {
          prop: 'IH_Invoice_No',
          label: 'Invoice NO',
        },
        {
          prop: 'RH_Receipt_Name',
          label: 'Receipt NO',
        },
        {
          prop: 'RH_Receipt_Status',
          label: 'Receipt Status',
        },
        {
          prop: 'RH_Receipt_Date_Convert',
          label: 'Receipt Date',
        },
        {
          prop: 'itemTotalAmount',
          label: 'Receipt Amount',
        },
        {
          prop: 'CRS_Course_Name',
          label: 'Level',
        },
        {
          prop: 'classNameBatch',
          label: 'Class',
        },
        {
          prop: 'RD_Item_Description',
          label: 'Fee Item Name',
        },
        {
          prop: 'RH_Receipt_Pay_Type',
          label: 'Payment Mode',
        },
        {
          prop: 'Remarks',
          label: 'Remarks',
        },
        {
          prop: 'itemBefGSTTotalAmount',
          label: 'itemBefGSTTotalAmount',
        },
      ],

      TranCNListInt: [],
      TranCNList: [
        {
          prop: 'Full_Name',
          label: 'First Name',
        },
        {
          prop: 'Last_name',
          label: 'Last Name',
        },
        {
          prop: 'Index_No',
          label: 'Student ID',
        },
        {
          prop: 'IH_Invoice_No',
          label: 'Credit Note No',
        },
        {
          prop: 'IH_Invoice_Name',
          label: 'Invoice No',
        },
        {
          prop: 'IH_Invoice_Date_Convert',
          label: 'Invoice Date',
        },
        {
          prop: 'itemTotalAmount',
          label: 'Total Amount',
        },
        {
          prop: 'CRS_Course_Name',
          label: 'Level',
        },
        {
          prop: 'classNameBatch',
          label: 'Class',
        },
        {
          prop: 'ID_Item_Description',
          label: 'Fee Item Name',
        },
        {
          prop: 'INV_Invoice_DueDate_Convert',
          label: 'Invoice Due Date',
        },
        {
          prop: 'Remarks',
          label: 'Remarks',
        },
        {
          prop: 'itemBefGSTTotalAmount',
          label: 'itemBefGSTTotalAmount',
        },
      ],

      AuditDisabled: false,
    }
  },
  methods: {
    loadSelector() {
      try {
        this.ClearSelectionValue()
        this.ClearAllList()
      } catch (e) {
        this.results = e
      }
    },
    initloadList(value) {
      this.ddlDocSelectedValue = value
      //console.log(this.ddlDocSelectedValue);
    },
    ClearAllList() {
      this.TranInvoiceListInt = []
      this.TranReceiptListInt = []
      this.TranCNListInt = []
    },

    async Search() {
      try {
        console.log(this.inputFromDate[0], this.inputFromDate[1], this.inputDateRange, this.ddlDocSelectedValue, 'this.ddlSelection=', this.ddlSelection)

        if (this.inputFromDate.length < 1 && !this.inputDateRange) {
          this.$notify({
            title: 'Require',
            message: '"Please select date."',
          })
        } else {
          this.$vs.loading()

          if (this.ddlSelectedValue === 'DateRange') {
            this.inputFromDate = []
          } else if (this.ddlSelectedValue === 'DateFrom') {
            this.inputDateRange = ''
          }
          const resp = await DataSource.shared.getTransactionListing(
            this.inputFromDate[0],
            this.inputFromDate[1],
            this.inputDateRange,
            this.ddlDocSelectedValue,
          )
          if (resp) {
            if (resp.code === '88') {
              window.location.replace('/')
            } else if (resp.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Search Student: Error',
              })
            } else if (resp.code === '2') {
              this.$notify.error({
                title: 'No Record',
                message: 'No Student Found',
              })
            } else {
              if (this.ddlDocSelectedValue == 'Invoice') {
                this.TranInvoiceListInt = resp.Table
              } else if (this.ddlDocSelectedValue == 'Receipt') {
                this.TranReceiptListInt = resp.Table
              } else if (this.ddlDocSelectedValue == 'cn') {
                this.TranCNListInt = resp.Table
              }
            }
            this.$vs.loading.close()
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    async Download() {
      this.exportExcel()
    },

    async ClearSelectionValue() {
      this.inputFromDate = []
      this.inputDateRange = ''
      this.ddlSelectedValue = ''
    },

    exportExcel() {
      let exportExcelObject = []

      var currentDateWithFormat = new Date().toJSON().slice(0, 10).replace(/-/g, '/')

      if (this.ddlDocSelectedValue == 'Invoice') {
        this.TranInvoiceListInt.forEach(m => {
          let tempList = {
            // Student_Name:m.studentName,
            First_Name: m.Full_Name,
            Last_Name: m.Last_name,
            Student_NO: m.Index_No,
            Invoice_NO: m.IH_Invoice_No,
            Invoice_Date: m.IH_Invoice_Date_Convert,
            Invoice_Amount: m.itemTotalAmount,
            Level: m.CRS_Course_Name,
            Class: m.classNameBatch,
            Fee_Item_Name: m.ID_Item_Description,
            Invoice_Due_Date: m.INV_Invoice_DueDate_Convert,
            Remarks: m.Remarks,
            itemBefGSTTotalAmount: m.itemBefGSTTotalAmount,
          }
          exportExcelObject.push(tempList)
        })
      } else if (this.ddlDocSelectedValue == 'Receipt') {
        this.TranReceiptListInt.forEach(m => {
          let tempList = {
            First_Name: m.Full_Name,
            Last_Name: m.Last_name,
            Student_NO: m.Index_No,
            Invoice_No: m.IH_Invoice_No,
            Receipt_NO: m.RH_Receipt_Name,
            Receipt_Status: m.RH_Receipt_Status,
            Receipt_Date: m.RH_Receipt_Date_Convert,
            Receipt_Amount: m.itemTotalAmount,
            Level: m.CRS_Course_Name,
            Class: m.classNameBatch,
            Fee_Item_Name: m.RD_Item_Description,
            Payment_Mode: m.RH_Receipt_Pay_Type,
            Remarks: m.Remarks,
            itemBefGSTTotalAmount: m.itemBefGSTTotalAmount,
          }
          exportExcelObject.push(tempList)
        })
      } else if (this.ddlDocSelectedValue == 'cn') {
        this.TranCNListInt.forEach(m => {
          let tempList = {
            // Student_Name:m.studentName,
            First_Name: m.Full_Name,
            Last_Name: m.Last_name,
            Student_NO: m.Index_No,
            CreditNote_NO: m.IH_Invoice_No,
            Invoice_NO: m.IH_Invoice_Name,
            Invoice_Date: m.IH_Invoice_Date_Convert,
            Invoice_Amount: m.itemTotalAmount,
            Level: m.CRS_Course_Name,
            Class: m.classNameBatch,
            Fee_Item_Name: m.ID_Item_Description,
            Invoice_Due_Date: m.INV_Invoice_DueDate_Convert,
            Remarks: m.Remarks,
            itemBefGSTTotalAmount: m.itemBefGSTTotalAmount,
          }
          exportExcelObject.push(tempList)
        })
      }

      var listItemCount = exportExcelObject.length
      var sheet1WS = XLSX.utils.json_to_sheet(exportExcelObject)
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      var newRange
      if (this.ddlDocSelectedValue == 'Invoice') {
        newRange = { s: { r: 0, c: 4 }, e: { r: listItemCount, c: 9 } }
        for (var R = newRange.s.r; R <= newRange.e.r; ++R) {
          for (var C = newRange.s.c; C <= newRange.e.c; ++C) {
            if (R <= listItemCount && C == 4) {
              var cell = sheet1WS[XLSX.utils.encode_cell({ r: R, c: C })]
              cell.z = 'd/m/yyyy'
              //console.log('R=',R,'C=',C);
            }
            if (R <= listItemCount && C == 5) {
              var fmt = '_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)'
              var cell = sheet1WS[XLSX.utils.encode_cell({ r: R, c: C })]
              cell.z = fmt
              //console.log('R=',R,'C=',C);
            }
            if (R <= listItemCount && C == 9) {
              var cell = sheet1WS[XLSX.utils.encode_cell({ r: R, c: C })]
              cell.z = 'd/m/yyyy'
              //console.log('R=',R,'C=',C);
            }
          }
        }
      } else if (this.ddlDocSelectedValue == 'Receipt') {
        newRange = { s: { r: 0, c: 5 }, e: { r: listItemCount, c: 6 } }
        for (var R = newRange.s.r; R <= newRange.e.r; ++R) {
          for (var C = newRange.s.c; C <= newRange.e.c; ++C) {
            if (R <= listItemCount && C == 5) {
              var cell = sheet1WS[XLSX.utils.encode_cell({ r: R, c: C })]
              cell.z = 'd/m/yyyy'
              //console.log('R=',R,'C=',C);
            }
            if (R <= listItemCount && C == 6) {
              var fmt = '_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)'
              var cell = sheet1WS[XLSX.utils.encode_cell({ r: R, c: C })]
              cell.z = fmt
              //console.log('R=',R,'C=',C);
            }
          }
        }
      }

      XLSX.utils.book_append_sheet(wb, sheet1WS, 'sheet1') // sheetAName is name of Worksheet
      XLSX.writeFile(wb, 'TransactionReport - ' + this.ddlDocSelectedValue + currentDateWithFormat + '.xlsx') // name of the file is 'book.xlsx'
    },
  },
}
</script>
<style>
.tl-search-bar .el-input input {
  background: transparent !important;
  border: 1px solid #eee !important;
}
.tl-search-bar .el-date-editor span.el-range-separator {
  padding: 0px;
  width: 20px;
}
</style>
<style scoped>
.tl-search-bar .el-select,
.tl-search-bar .el-date-editor {
  margin: 0 10px;
  flex: 1;
}
.tl-search-bar button {
  background: #007bff !important;
  color: white;
  border: 0px;
}

.tl-search-bar {
  display: flex;
  width: 100%;
  padding-bottom: 20px;
  border-bottom: 1px solid #edf0f4;
  margin-bottom: 20px;
}

.tl-sub-header {
  display: flex;
  align-items: center;
}

.tl-sub-header h5 {
  margin: 0px !important;
}

.tl-sub-button {
  margin-left: auto;
}

.tl-invoice,
.tl-receipt,
.tl-cn {
  width: 100%;
}
</style>
